import React, { useEffect, useRef } from 'react';

const CALENDLY_URL =
  'https://calendly.com/ueducate/book-a-demo?hide_event_type_details=1&hide_gdpr_banner=1';

function BookaDemo() {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const initWidget = () => {
      if (!window.Calendly || !el) return;
      // clear any previous embed before re-initialising (e.g. popup re-open)
      el.innerHTML = '';
      window.Calendly.initInlineWidget({
        url: CALENDLY_URL,
        parentElement: el,
      });
    };

    // Calendly's widget.js is loaded async in index.html, so it may not be
    // ready yet when this component mounts. Init immediately if available,
    // otherwise wait for the script to finish loading.
    if (window.Calendly) {
      initWidget();
      return;
    }

    const timer = setInterval(() => {
      if (window.Calendly) {
        clearInterval(timer);
        initWidget();
      }
    }, 200);
    const stop = setTimeout(() => clearInterval(timer), 10000);

    return () => {
      clearInterval(timer);
      clearTimeout(stop);
    };
  }, []);

  // Uses a ref instead of a shared id so multiple embeds (page + popup)
  // never collide.
  return (
    <div>
      <div ref={containerRef} />
    </div>
  );
}

export default BookaDemo;
